import { Component, OnInit, Renderer2 } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import * as SecureLS from "secure-ls";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { NgxSpinnerService } from "ngx-spinner";
import Swal from "sweetalert2";
import { GlobalService } from "src/app/services/global.service";
import Math from "exact-math";
import { StorageService } from "../../services/storage.service";
@Component({
  selector: "app-department",
  templateUrl: "./department.component.html",
  styleUrls: ["./department.component.css"],
})
export class DepartmentComponent implements OnInit {
  // Modal
  submitted = false;
  private ls = new SecureLS({ encodingType: "aes" });
  departmentList: any[];
  page: number = 1;
  page_size: number = 10;
  getdepartment: Object;
  total_count: any;
  roleID = this.storageService.getRole();
  userID = this.ls.get("createdBy");
  alphaPattern = "[a-zA-Z .,]*";
  deptname = "";
  departmentForm: FormGroup;
  editbut = false;
  showLoadMore = false;
  departcreate: any;
  isactiveswitch: any;
  departupdate: any;
  editdepartment: Object;
  editid: any;
  editstatus: any;
  departstatusupdate: Object;
  is_active: any;
  deletedepartment: Object;
  manualUpdate: boolean;
  page_count = [];
  pageshow = true;
  htmlpageshow: boolean;
  total: any;
  p: number;
  pagedItems: any[];
  searchForm: FormGroup;
  filtervalues: boolean;
  chiparray: any = [];
  entryFields: boolean = false;
  createNew: boolean = true;
  backendValidationErrors: any;

  constructor(
    private storageService: StorageService,
    private modalService: NgbModal,
    private fb: FormBuilder,
    public router: Router,
    public globalService: GlobalService,
    private spinner: NgxSpinnerService,
    private renderer: Renderer2
  ) {}

  // Modal
  openScrollableContent(longContent) {
    if (this.ls.get("token")) {
      this.modalService.open(longContent, { scrollable: true });
    }
  }
  async ngOnInit() {
    this.searchForm = this.fb.group({
      id: [""],
      depname: [""],
    });
    this.departmentForm = this.fb.group({
      id: [""],
      name: ["", [Validators.required]],
      is_active: [""],
    });
    this.page = 1;
    this.departmentForm.valueChanges.subscribe((data)=>{
      this.backendValidationErrors = null;
    });
    await this.getDepartment();
    await this.getPage(this.page, true);
  }

  openField() {
    this.entryFields = true;
    this.createNew = false;
    this.departmentForm.reset();
    this.submitted = false;
  }
  openEdit() {
    this.entryFields = true;
    this.createNew = false;
    this.editbut = false;
    this.departmentForm.reset();
    this.submitted = false;
  }

  cancelFields() {
    this.renderer.removeClass(document.body, "modal-open");
    this.entryFields = false;
    this.departmentForm.reset();
    this.createNew = true;
  }

  get forms() {
    return this.departmentForm.controls;
  }

  get forms1() {
    return this.searchForm.controls;
  }

  Filter(deptname) {
    this.filtervalues = true;
    this.chiparray = [];
    if (this.deptname != undefined && this.deptname != "") {
      this.chiparray.push("Dept :" + " " + this.deptname);
    }

    this.deptname = deptname;
    this.pageshow = true;
    this.page = 1;
    this.getDepartment();
  }
  res() {
    this.filtervalues = false;
    this.deptname = null;
    this.searchForm.reset();
    this.pageshow = true;
    this.page = 1;
    this.getDepartment();
  }
  async getPage(page: number, disableCall: boolean) {
    this.page = page;
    if(!disableCall) {
      await this.getDepartment();
    }
    
    const res = await this.serverCall(this.departmentList, page);
    this.total = this.total_count;
    this.p = page;

    this.pagedItems = res;
  }

  async serverCall(sample: any[], page: number) {
    const perPage = this.page_size;
    const start = (page - 1) * perPage;
    const end = start + perPage;
    return sample;
  }
  getDepartment() {
    this.spinner.show();
    if (this.page === 1) {
      this.departmentList = [];
    }

    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      page: this.page,
      role_id: this.storageService.getRole(),
      name: this.deptname ? this.deptname : "",
      page_size: this.page_size,
    };
    this.globalService.get("department/list", filter).then((data) => {
      this.getdepartment = data;
      this.spinner.hide();
      if (this.getdepartment["status"] === 200) {
        this.total_count = this.getdepartment["content"].count;
      if (this.getdepartment["content"]["rows"].length < this.page_size) {
        this.showLoadMore = true;
      }
        this.departmentList = this.getdepartment["content"]["rows"];

        if (this.pageshow === true) {
          this.page_count = [];
          let page_count = Math.ceil(this.total_count / this.page_size);
          if (page_count > 1) {
            this.htmlpageshow = true;
          } else {
            this.htmlpageshow = false;
          }
        }
      } else {
        this.htmlpageshow = false;
        this.showLoadMore = true;
        this.spinner.hide();
      }
    });
  }
  async createDepartment(form: FormGroup) {
    this.submitted = true;

    if (this.departmentForm.invalid) {
      return;
    }
    this.spinner.show();
    const departmentName = form.value.name.trim();
    const inputData = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      name: departmentName,
      is_active: this.isactiveswitch
        ? this.isactiveswitch == true
          ? "1"
          : "0"
        : "0",
    };
    this.departcreate = await this.globalService.create(
      "department/create",
      inputData
    );

    if (this.departcreate["status"] === 200) {
      Swal.fire("Success!", this.departcreate["message"], "success");
      this.spinner.show();
      this.pageshow = true;
      this.getDepartment();
      this.reset();
      this.entryFields = false;
      this.createNew = true;
      this.backendValidationErrors = null;
      this.renderer.removeClass(document.body, 'modal-open')
    } else if(this.departcreate["status"] === 422){
      this.backendValidationErrors = this.departcreate?.error["content"];
    } else {
      this.cancelFields();
      this.backendValidationErrors = null;
    }
    this.spinner.hide();
  }

  departmentStatusUpdate(value: boolean, id) {
    this.spinner.show();
    Swal.fire({
      title: "Are you sure?",
      text: "Are you sure you want to Change Status?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        let status;

        this.manualUpdate = value;
        if (value == false) {
          status = "0";
        } else if (value == true) {
          status = 1;
        }
        const inputData = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          id: id ? id : this.editid,
          is_active: status,
        };
        this.departstatusupdate = await this.globalService.update(
          "department/update/status",
          inputData
        );
        if (this.departstatusupdate["status"] === 200) {
          Swal.fire("Success!", this.departstatusupdate["message"], "success");
          this.pageshow = true;
          this.getDepartment();
        }
        if (this.departstatusupdate["status"] != 200) {
          this.pageshow = true;
          this.getDepartment();
        }
      } else {
        this.pageshow = true;
        this.getDepartment();
      }
    });
    this.spinner.hide();
  }
  async deleteDepartment(id) {
    this.spinner.show();
    Swal.fire({
      title: "Delete ?",
      text: "Are you sure you want to delete this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        let filter = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          id: id,
        };
        this.deletedepartment = await this.globalService.delete(
          "department/delete",
          filter
        );
        if (this.deletedepartment["status"] === 200) {
          this.departmentList = [];
          Swal.fire("Success!", this.deletedepartment["message"], "success");
          this.pageshow = true;
          this.getDepartment();
        }
      }
    });
    this.spinner.hide();
  }

  async updateDepartment(form: FormGroup) {
    this.submitted = true;
    if (this.departmentForm.invalid) {
      return;
    }
      this.spinner.show();

      const inputData = {
        id: form.value.id,
        vendor_id: this.ls.get("vendor_id"),
        name: form.value.name.trim(),
        is_active: this.is_active
          ? this.is_active == true
            ? "1"
            : "0"
          : this.editstatus,
        user_id: this.ls.get("createdBy"),
      };
      this.departupdate = await this.globalService.update(
        "department/update",
        inputData
      );

      if (this.departupdate["status"] === 200) {
        Swal.fire("Success!", this.departupdate["message"], "success");
        this.pageshow = true;
        this.getDepartment();
        this.editbut = false;
        this.reset();
        this.entryFields = false;
        this.createNew = true;
        this.backendValidationErrors = null;
        this.renderer.removeClass(document.body, 'modal-open')
      } else if(this.departupdate["status"] === 422){
        this.backendValidationErrors = this.departupdate?.error["content"];
      } else {
        this.cancelFields();
        this.backendValidationErrors = null;
      }
      this.spinner.hide();
  }

  editDepartment(id) {
    Swal.fire({
      title: "Edit ?",
      text: "Are you sure you want to edit this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        this.spinner.show();
        this.editbut = true;
        this.openField();
        let filter = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          id: id,
        };
        this.editdepartment = await this.globalService.get(
          "department/get",
          filter
        );
        let comp_details = this.editdepartment["content"];
        if (this.editdepartment["status"] === 200) {
          this.departmentForm.controls["id"].setValue(comp_details.id);
          this.departmentForm.controls["name"].setValue(comp_details.name);
          this.editid = comp_details.id;
          this.editstatus = comp_details.is_active;
        }
        this.spinner.hide();
      } else {
        this.cancelFields();
      }
    });
  }
  reset() {
    this.submitted = false;
    this.departmentForm.reset();
    this.isactiveswitch = false;
  }

  formAddReset() {
    this.departmentForm.reset();
    this.editbut = false;
  }
  formUpdateReset() {
    this.departmentForm.controls["id"].setValue(
      this.editdepartment["content"].id
    );
    this.departmentForm.controls["name"].setValue(
      this.editdepartment["content"].name
    );
    this.departmentForm.reset();
    this.departmentForm.get("id").setValue(this.editdepartment["content"].id);
  }
  switch(e) {
    this.isactiveswitch = e;
  }
  loadMore(index) {
    this.pageshow = true;
    this.page = index;
    this.getDepartment();
  }
  previous() {
    this.pageshow = true;
    this.page = this.page - 1;
    this.getDepartment();
  }

  next() {
    this.pageshow = true;
    this.page = this.page + 1;
    this.getDepartment();
  }
  paginationCount(value) {
    this.page = 1;
    if (value >= 5) {
      this.page_size = value;
    }
    this.getDepartment();
  }
}
